// extracted by mini-css-extract-plugin
export default {"escapeUrl":"view-plans_escapeUrl_oOokB"};